import MenuIcon from '@mui/icons-material/Menu'
import { getAuthenticator, logout } from '../auth/auth';
import { useState } from 'react';
import { cleanup } from "../auth/role"


export function collapseSidebar () {
    let body = document.body;
    if(body.className.indexOf('sidebar-collapse') === -1){
        body.className += ' sidebar-collapse';
        body.className = body.className.replace(' sidebar-open', '');
    }
}

export function expandSidebar () {
    let body = document.body;
    if (body.className.indexOf('sidebar-open') === -1) {
        body.className += ' sidebar-open';
        body.className = body.className.replace(' sidebar-collapse', '');
    }
}

export default function Header(props = {}) {
    const [account, setAccount] = useState(getAuthenticator().getCurrentAccount())

    const pushMenu = () => {
        let body = document.body;
        if(body.clientWidth > 768){
            if(body.className.indexOf('sidebar-collapse') === -1){
                body.className += ' sidebar-collapse';
            } else {
                body.className = body.className.replace(' sidebar-collapse', '');
            }
        } else {
            if (body.className.indexOf('sidebar-open') === -1) {
                body.className += ' sidebar-open';
            } else {
                body.className = body.className.replace(' sidebar-open', '');
            }
        }
    }
  
    return (
        <header className="main-header">
            <a href="/" className="logo">
            {props.appName}
            </a>
            <nav className="navbar navbar-static-top" role="navigation">
                <a href="#" className="sidebar-toggle" data-toggle="offcanvas" role="button" onClick={pushMenu}>
                    <MenuIcon/><span className="sr-only"> Toggle navigation</span>
                </a>
                <span style={{float:"right", color:"white", paddingRight: "2em"}}>
                    <span>Welcome {account?.name || ''}!</span>
                    <span>
                        <a href="#" onClick={() => {
                            cleanup()
                            logout()
                        }} role="button" style={{color:"white", paddingLeft: "2em"}}>Logout</a></span>
                </span>
                {/*<div className="navbar-custom-menu">
                    <ul className="nav navbar-nav">
                        <li>
                            <a href="#" data-toggle="control-sidebar"><i className="fa fa-gears"></i></a>
                        </li>
                    </ul>
                </div>*/}
            </nav>
        </header>
    )
}